import React from 'react';
import getTableCellsTillBreak from '../utils/getTableCellsTillBreak';
import { useFromStore } from '../../utils/createStore';
var CONTROL_COLUMN_SIZE = 41;

function TableStyle(_ref) {
  var tableId = _ref.tableId,
      table = _ref.table,
      store = _ref.store,
      readOnly = _ref.readOnly;

  var _ref2 = useFromStore(store, tableId) || {},
      resizingColumn = _ref2.resizingColumn,
      resizingColumnWidth = _ref2.resizingColumnWidth;

  var firstRow = React.useMemo(function () {
    return getTableCellsTillBreak(table.nodes);
  }, [table]);
  var minWidth = React.useMemo(function () {
    return firstRow.reduce(function (memo, cell, index) {
      return memo + (resizingColumn === index ? resizingColumnWidth : cell.getIn(['data', 'width'], 0) || 200);
    }, 0) + (readOnly ? 0 : CONTROL_COLUMN_SIZE);
  }, [firstRow, resizingColumn, resizingColumnWidth, readOnly]);
  return React.createElement("style", null, "\n      [data-slite-editor-table=\"".concat(tableId, "\"] {\n        min-width: ").concat(minWidth, "px;\n      }\n    "));
}

export default React.memo(TableStyle);